import { Directive } from '@angular/core';
import { DocumentTypeELynkPacketAddMode, DocumentTypeELynkPacketChecklistMode } from "src/app/models/document";
import { ActionService } from 'src/app/services/actions/action.service';
import { ConfigurationService } from "src/app/services/configuration/configuration.service";
import { GetDocumentTypesRequest, GetDocumentTypesResponse } from 'src/app/services/document-type/document-type-plugin-models';
import { DocumentTypeTreeNode, ELynkPacket, ELynkPacketAdd, ELynkPacketChecklist } from "src/app/services/document-type/document-type.model";

export class SelectButtonOption {
    label: string;
    value: boolean;
}
@Directive()
export class DocumentTypeBaseComponent {
    defaultSelectButtonOptions: SelectButtonOption[] = [
        { label: 'No', value: false },
        { label: 'Yes', value: true }
    ];

    ActionType: string = "DocumentTypes";

    constructor(public configurationService: ConfigurationService,
        public actionService: ActionService) {

    }

    newPacket: ELynkPacket = {
        id: "",
        add: {
            visible: DocumentTypeELynkPacketAddMode.Hidden,
            editable: false
        } as ELynkPacketAdd,
        checklist: {
            categoryId: "",
            mode: DocumentTypeELynkPacketChecklistMode.Optional,
            editable: false,
        } as ELynkPacketChecklist
    };

    protected async getDocumentTypes(): Promise<DocumentTypeTreeNode[]> {
        const request = new GetDocumentTypesRequest();
        let response = await this.actionService.invoke(this.ActionType, "document-types-get", request) as GetDocumentTypesResponse;
        return response.documentTypes.sort((a, b) => {
            if (a.description > b.description) {
                return 1;
            }
            if (a.description < b.description) {
                return -1;
            }
            return 0;
        });
    }
}
